import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

type AutoLoadMoreOnScrollProps = {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onLoadMore: () => void;
  rootMargin?: string;
};

export const AutoLoadMoreOnScroll = ({
  hasNextPage,
  isFetchingNextPage,
  onLoadMore,
  rootMargin = "200px 0px"
}: AutoLoadMoreOnScrollProps) => {
  const { ref, inView } = useInView({
    rootMargin,
    threshold: 0
  });

  useEffect(() => {
    if (!inView) return;
    if (!hasNextPage) return;
    if (isFetchingNextPage) return;
    onLoadMore();
  }, [inView, hasNextPage, isFetchingNextPage, onLoadMore]);

  return <div ref={ref} className="h-1 w-full" />;
};
